// @ts-nocheck
import { Component, ElementRef, TemplateRef, ViewChild, NO_ERRORS_SCHEMA } from '@angular/core';
import { UtilsDataService } from 'src/app/services/utils-data.service';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { VendorService } from 'src/app/services/vendor.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { HeaderLatestComponent } from '../../home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from '../../peopleflow-footer/peopleflow-footer.component';
@Component({
  standalone: true,
  selector: 'app-support-documents',
  templateUrl: './support-documents.component.html',
  styleUrl: './support-documents.component.scss',
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatRadioModule, MatButtonModule, MatIconModule, HeaderLatestComponent, PeopleflowFooterComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SupportDocumentsComponent {
  [key: string]: any;
  constructor(
    private fb: FormBuilder,
    private vendorService: VendorService,
    private snackbarService: SnackBarService,
    private utilsDataService: UtilsDataService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {}

  getVendorDocuments(obj: any) {}

  initDocuments() {}

  prepareDocuments() {}

  onSubmit() {}

  handleFileInput(event: any, type: string) {}

  imageCropped(event: any) {}

  convertObjectUrlToBase64(objectUrl: string) {}

  panValidator(): ValidatorFn {}

  cinValidator(): ValidatorFn {}

  gstValidator(): ValidatorFn {}

  openErrorDialog(msg: string) {}

  viewDetails(obj: any) {}

  isImage(fileName: string) {}

  isAnyDocumentValid(): boolean {}

  onSkip() {}
}
